module.exports = __webpack_public_path__ + "static/media/editar.90e9dc7c.svg";